<template>
    <Modal :is_show="is_show" @click-bg="close()" class="add-creator-modal add-ageement-modal edit-program-set-pop">
        <header class="edit_program_header">
            Agreements & Disclaimers
            <i @click="close()"><svg-icon name="close" /></i>
        </header>

        <Scrollbar class="edit-scroll-list" :show_bar="true">
            <ProgAgreement :data="data" @save="saveSetting" :brand_name="brand_name" />
        </Scrollbar>
    </Modal>

      
</template>

<script>
import Modal from '@/components/ui/Modal.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import ProgAgreement from './ProgAgreement.vue';

export default {
    name: 'ProgramForm-pae',
    emits: ['close','save','del'],

    data() {
        return {
            handle_data:{},
            is_show_alert_modal:false,
        }
    },

    props: {
        is_show: {
            type: Boolean,
            default: true,
        },
        data: {
            type: Object,
            default: {}
        },
        barnd_name:{
            type: String,
            default: '',
        }
    },

    components: {
        Scrollbar,
        ProgAgreement,
        Modal,
    },
    
    methods: {
        close(){
            this.$emit('close');
        },

        saveSetting(data){
            this.$emit('save', data);
        },
    },



}
</script>

<style lang="scss">
</style>